import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { createStructuredSelector } from 'reselect';
import ChooseAccommodation from '../components/ChooseAccommodation';
import {
  numberOfNightsSelector,
  numberOfGuestsSelector,
  startDateSelector,
  endDateSelector,
  propertySelector,
  submittedAccountSelector,
  selectedOffersSelector,
  isAdminSelector,
  activeBlockSelector,
  secondSubmittedAccountSelector,
  isWaitListBookingSelector,
  waitListBookingReasonSelector
} from 'routes/DateSelection/selectors';
import {
  filteredRoomsSelector,
  filtersSelector,
  selectedRoomSelector,
  shouldRefetchSelector
} from 'routes/ChooseAccommodation/selectors';
import {
  selectRoom,
  updateFilters,
  setShouldRefetch
} from 'routes/ChooseAccommodation/reducer';
import { getBookingEnginePath } from 'utils/routeUtils';
import { setNumberOfGuests, setQueryInput } from 'routes/DateSelection/reducer';
import { bookingSourceSelector } from '../../selectors';

const mapStateToProps = createStructuredSelector({
  selectedRoom: selectedRoomSelector,
  numberOfNights: numberOfNightsSelector,
  filteredRooms: filteredRoomsSelector,
  filters: filtersSelector,
  numberOfGuests: numberOfGuestsSelector,
  startDate: startDateSelector,
  endDate: endDateSelector,
  property: propertySelector,
  submittedAccount: submittedAccountSelector,
  selectedOffers: selectedOffersSelector,
  shouldRefetch: shouldRefetchSelector,
  isAdmin: isAdminSelector,
  activeBlock: activeBlockSelector,
  bookingSource: bookingSourceSelector,
  secondSubmittedAccount: secondSubmittedAccountSelector,
  isWaitListBooking: isWaitListBookingSelector,
  waitListBookingReason: waitListBookingReasonSelector
});

function mapDispatchToProps(dispatch) {
  return {
    selectRoom: room => {
      dispatch(selectRoom(room));

      return dispatch(push(getBookingEnginePath('guest-information')));
    },
    updateFilters: values => {
      const updatedValues = Object.assign({}, values, {
        roomType: values.roomType.value === 'All' ? null : values.roomType
      });

      dispatch(setNumberOfGuests(values.numberOfGuests));

      return dispatch(updateFilters(updatedValues));
    },
    setQueryInput: currentMonthStart =>
      dispatch(setQueryInput(currentMonthStart)),
    setShouldRefetch: shouldRefetch => dispatch(setShouldRefetch(shouldRefetch))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChooseAccommodation);
